<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 14:40:25
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="nursing-batch">
    <div :class="['nursing-batch-head', isApp?'no-header':'']">
      <div class="implement-filter">
        <filterBtn></filterBtn>
        <div class="btn-list">
            <div v-if="implementType==1" @click="allSetUp(false)" class="all-btn all-cancel" type="primary" plain>全部取消</div>
            <div v-if="implementType==1" @click="allSetUp(true)" class="all-btn all-sure" type="primary" plain>全部确认</div>
        </div>
      </div>
      <!-- <div class="tabs-container">
        <div class="tabs">
          <div :class="['tab-block',tabPosition==item?'tab-block-active':'']" @click="changeTabs(item)" v-for="item in tabs" :key="item">{{item}}</div>
        </div>
      </div> -->
    </div>
    <div :class="['implement-row', isApp?'no-header1':'']">
      <div @click="selectImplement(1)" :class="[implementType==1?'active-implement':'','already-implement']">未执行</div>
      <div @click="selectImplement(2)" :class="[implementType==2?'active-implement':'','not-implement']" >已执行</div>
    </div>


    <!-- <div class="list-transition-container">
        <div class="list-transition" v-for="item in tabs" :key="item">
        <transition >
          <div class="list" v-if="tabPosition==item">
            <div class="block" v-for="item in implementList" :key="item.Id">
              <implementItemHeader :name="item.ProfileName" :time="item.newDTime" :avatar="item.ImgUrl" :room="item.RoomNo"></implementItemHeader>
              <div class="line"></div>
              <implementItemFooter :obj="item" :task="item.Message" :status="item.Status" :oldStatus="item.oldStatus" :time="item.newDTime" :InputDate="item.newInputDate" :remark="item.Remark" :userName="item.CUser"
              :Value="item.Value" @check="check" @close="close" @getHistory="getHistory" @setRemark="setRemark" ></implementItemFooter>
            </div>
          </div>
        </transition>
      </div>
    </div> -->
    <div class="list">
      <template v-if="implementList&&implementList.length">
        <div class="block" v-for="item in implementList" :key="item.Id">
          <implementItemHeader :name="item.ProfileName" :time="item.newDTime" :avatar="item.ImgUrl" :room="item.RoomNo"></implementItemHeader>
          <div class="line"></div>
          <implementItemFooter :obj="item" :task="item.Message" :status="item.Status" :oldStatus="item.oldStatus" :time="item.newDTime" :InputDate="item.newInputDate" :remark="item.Remark" :userName="item.CUser"
          :hasHistoryRecords="item.HistoryRecords?item.HistoryRecords.length>0:false" :Value="item.Value" @check="check" @close="close" @getHistory="getHistory" @setRemark="setRemark" ></implementItemFooter>
        </div>
      </template>
      <tips v-else></tips>
    </div>
    <pager @changePage="changePage" @changeSize="changeSize" :page='page+1' :total="total" :size="size"></pager>
    <!-- 全部执行弹框-->
    <myDialog :dialogVisible="dialogVisible" :question="question" @close="allClose" @setup="allSetup" dialogWidth="66%"></myDialog>
    <!-- 执行弹框-->
    <template>
        <implementRemark :activeObj="activeObj" :isVisible='implementVisible' :remakeType="remakeType" :ProfileName="activeObj.ProfileName" :Message="activeObj.Message"
        :initRemark="activeObj.Remark" :initInput="activeObj.Value" :ImgUrl="activeObj.ImgUrl" :initStatus='activeObj.Status' :initModels="cloneDeep(activeObj.Models)" :Id='activeObj.Id'
        :InputType="activeObj.InputType" @close="closeRemark" @closeStatus="closeStatus" @execution="execution"></implementRemark>
    </template>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash'
import implementRemark from '@/common/implement-remark.vue'
import {group,timeCompared,compare} from '@/tool'
import { mapState,mapActions } from 'vuex'
import filterBtn from '@/common/filter-btn.vue'
import myDialog from '@/common/dialog.vue'
import pager from '@/common/pager.vue'
import tips from '@/common/tips.vue'
import implementItemHeader from '@/common/implement-item-header.vue'
import implementItemFooter from '@/common/implement-item-footer.vue'
import filter from '../../store/modules/filter'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    implementRemark,
    filterBtn,
    myDialog,
    pager,
    implementItemFooter,
    implementItemHeader,
    tips
  },
  // 组件状态值
  data () {
    return {
      size:10,
      page:0,
      total:10,
      activeObj:{},
      isApp:true,
      //1完成弹框2拒绝弹框3备注
      remakeType:1,
      implementVisible:false,
      dialogVisible:false,

      tabPosition:'时间表',
      tabs:['时间表','入住老人','房间号','项目'],
      isAll:false,
      dialogVisible:false,
      question:"是否确认所有记录？",

      implementType:1
    }
  },
  // 计算属性
  computed: {
    ...mapState(['ElderlyCares','Items','NurseSignatureViews','saveVal']),
    ...mapState('filter',['selectDetails','selectRooms','activeShifts']),
    elder(){
        return this.ElderlyCares.filter(item=>item.Id==this.$route.query.Id)[0]
    },
    implementHistory(){
        let ItemsArr=this.Items.filter(item=>{
            let time=item.DTime.split('T')[1]
            item.timestamp=new Date(item.DTime).getTime()
            return (!this.selectDetails.length||this.selectDetails.indexOf(item.Message)!=-1)&&
            (!this.activeShifts.length||this.activeShifts.indexOf(timeCompared(time,filter.state.shiftTimeList,filter.state.shifts))!=-1)&&
            (!this.selectRooms.length||this.selectRooms.indexOf(item.RoomNo)!=-1)&&
            (this.implementType==1?item.oldStatus===null:item.oldStatus!==null)

        })
        if(this.tabPosition=='项目'){
          ItemsArr.sort(compare('Message'))
        }else if(this.tabPosition=='入住老人'){
          ItemsArr.sort(compare('ProfileName'))
        }else if(this.tabPosition=='房间号'){
          ItemsArr.sort(compare('RoomNo'))
        }else{
          ItemsArr.sort(compare('timestamp'))
        }
        this.total=ItemsArr.length
        if(this.page*this.size>=this.total){
          this.page=0
        }
        return ItemsArr
    },
    implementHistoryArr(){
        let ItemsArr=group(this.implementHistory,this.size)
        return ItemsArr||[[]]
    },
    implementList(){
      return this.implementHistoryArr[this.page]
    },
  },
  // 侦听器
  watch: {
    saveVal(val){
      let nowTime=new Date().getTime()
      let Items=this.implementHistory.filter(item=>item.IsEdit==1)
      if(Items.length){
        this.updateNursingInformation({
          ElderlyCares:this.ElderlyCares,
          Items,
          NurseSignatureViews:this.NurseSignatureViews
        })
      }else{
        let editArr=this.implementHistory.filter(item=>item.IsEdit==1)
        this.$message({
          message: editArr.length?'不允许保存未来时间点的项目！':'请先选择项目!',
          type: 'warning',
          customClass:"custom-message"
        });
      }
    }
  },
  // 组件方法
  methods: {

    ...mapActions(['updateNursingInformation']),
    changeTabs(tabPosition){
      this.tabPosition=tabPosition
    },
    cloneDeep(val){
      return cloneDeep(val)
    },
    changePage(page){
      this.page=page
    },
    changeSize(size){
      this.size=size
    },
    //关闭执行弹框
    closeRemark(data){
        this.implementVisible=false
        this.activeObj={}
    },
    //取消缓存执行
    closeStatus(id){
        this.implementList.map(item=>{
            if(item.Id==id){
                this.reduction(item)
            }
        })
    },
    //取消执行还原对象
    reduction(item){
        let arr=[]
        item.IsEdit=0
        //还原完成执行缓存的对象
        arr=['oldStatus','oldValue','oldRemark','oldModels']
        arr.map((str)=>{
            if(item.hasOwnProperty(str)){
                //Models和oldModels不相等，重新赋值触发activeObj的更新从而触发:initModels="cloneDeep(activeObj.Models)"的更新
                item[str.substring(3)]=(str=='oldModels'?cloneDeep(item[str]):item[str])
            }
        })
    },
    //确认执行操作
    execution(data){
        this.implementList.map(item=>{
            if(item.Id==data.id){
                item.Status=data.status
                item.Remark=data.remark
                item.IsEdit=1
                //如果是确认执行，则对更新值和Models模型
                if(this.remakeType==1){
                    item.Value=data.input
                    item.Models=cloneDeep(data.models)
                    // item.Models=data.models
                //如果是确认未完成和备注，则要还原之前可能输入过的其他值
                }else if(this.remakeType==2){
                    item.Value=item.oldValue
                    item.Models=cloneDeep(item.oldRemark)
                    // item.Models=item.oldModels
                }

            }
        })
    },
    //打开执行弹框
    check(data){
        if (data.VitalId || data.InputType === 0 || data.InputType == 1 || data.InputType == 2) {
            this.remakeType=1
            this.implementVisible=true
            this.activeObj= data
        }else{
          if(data.Status==0){
            data.Status=null
            data.IsEdit=0
          }else{
            data.Status=0
            data.IsEdit=1
          }
          this.activeObj= data
        }
    },
    //打开拒绝弹框
    close(data){
        this.remakeType=2
        this.implementVisible=true
        this.activeObj= data
    },
    //打开备注弹框
    setRemark(data){
        this.remakeType=3
        this.implementVisible=true
        this.activeObj= data
    },
    getHistory(obj){
        this.$router.push({
          name:'implementHistory' ,
          query: { Id:obj.ProfileId ,itemId:obj.Id,message:obj.Message}
        })
    },
    allSetUp(val){
      this.dialogVisible=true
      this.isAll=val
      val?this.question='是否确认所有记录(不包含需要输入相关数值的记录)？':this.question='是否确认全部取消？'
    },
    allClose(){
      this.dialogVisible=false
    },
    //确认全部执行
    allSetup(){
        // this.implementList.map(item=>{
          this.implementHistory.map(item=>{
            if (item.oldStatus===null&&(item.InputType == 0||item.InputType == 3)) {
                if(this.isAll){
                    item.IsEdit=1
                    item.Status=0
                }else{
                  if(item.Status==0){
                      item.IsEdit=0
                      item.Status=item.oldStatus
                      item.Remark=item.oldRemark
                      item.Value=item.oldValue
                  }
                }
            }
        })
    },
    selectImplement(implementType){
      this.implementType=implementType
    }

  },

  created () {
    this.isApp= localStorage.getItem('isApp') === '0'
  },

  beforeDestroy () {
    if(this.isAll){
      this.isAll=false
      this.allSetup()
    }

  },
}
</script>

<style scoped>
/* .list-transition-container{
  position: relative;
}
.list-transition{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 750px;
}
.v-enter-active,.v-leave-active {
  transition: all .4s ease;
}
.v-enter{
  transform: translateX(750px);
}
.v-enter-to {
  transform: translateX(0px);
}
.v-leave{
  transform: translateX(0px);
}
.v-leave-to {
  transform: translateX(-750px);
} */

.nursing-batch-head{
  position: fixed;
  top: 93px;
  left: 0px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  background: #fff;
}

.no-header {
  top: 48px !important;
}

.line{
  width: 100%;
  height: 1px;
  background: #EBEBEB;
}
.implement-filter{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #fff;
}
.all-btn{
  font-size: 12px;
  width: 67px;
  height: 24px;
}
.tabs{
  display: flex;
  justify-content: center;
}
.tab-block{
  width: 69px;
  height: 32px;
  line-height: 32px;
  color: #029FD1;
  font-size: 24px;
  text-align: center;
  border-top: 1px solid #029FD1;
  border-right: 1px solid #029FD1;
  border-bottom: 1px solid #029FD1;
}
.tab-block:first-child{
  border-left: 1px solid #029FD1;
  border-radius: 2px 0px 0px 2px;
}
.tab-block:last-child{
  border-radius: 0px 2px 2px 0px;
}
.tab-block-active{
  background: #029FD1;
  color: #fff;
}
.tabs-container{
  text-align: center;
  margin: 12px 0px ;
}

.btn-list{
    display: flex;
    align-content: center;
}
.all-btn{
    font-size: 12px;
    width: 67px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 2px;
    box-sizing: border-box;
}
.all-cancel{
    background: #DCF7FF;
    color: #029FD1;
    border: 1px solid #029FD1;
}
.all-sure{
    background: #029FD1;
    color: #FFFFFF;
    margin-left: 15px;
}
.list{
  margin: 153px 15px 0px 15px;
  padding-bottom: 30px;
}
.block{
  background: #fff;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 4px;
}

.implement-row{
  position: fixed;
  top: 143px;
  left: 0px;
  font-size: 16px;
  width: 100%;
  padding: 8px 15px;
  display: flex;
  justify-content: space-between;
  background: #F7F8FA;
  box-sizing: border-box;
  z-index: 1;
}
.no-header1 {
    top: 94px !important;
}
.already-implement,.not-implement{
  position: relative;
  width: 163px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #DCF7FF;
  color: #029FD1;
}
.already-implement::after{
  position: absolute;
  right: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 36px solid #DCF7FF;
  border-right: 12px solid transparent;
  content: "";
}
.not-implement::after{
  position: absolute;
  left: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 36px solid #DCF7FF;
  border-left: 12px solid transparent;
  content: "";
}
.active-implement{
  background-color: #029FD1;
  color: #fff;
}
.active-implement::after{
  border-top-color: #029FD1;
  border-bottom-color: #029FD1;
}
</style>



// WEBPACK FOOTER //
// src/components/nursing/nursing-batch-implement.vue